export enum AudioControllerEvent {
  'AUDIO_CONTROLLER_RECORD_STARTED' = 'AUDIO_CONTROLLER_RECORD_STARTED',
  'AUDIO_CONTROLLER_EXPORT_PROGRESS' = 'AUDIO_CONTROLLER_EXPORT_PROGRESS',
}
